// export DsfNavTab from "./navTab";
// export DsfTabItem from "./tabItem";
// export DsfStepsNav from "./stepsNav";

export const DsfNavTab = dsf.defineAsyncComponent("DsfNavTab", () =>
  import(/*webpackChunkName:"platform_pc_other"*/ "./navTab.vue")
);
export const DsfTabItem = dsf.defineAsyncComponent("DsfTabItem", () =>
  require(/*webpackChunkName:"platform_pc_other"*/ "./tabItem")
);
export const DsfStepsNav = dsf.defineAsyncComponent("DsfStepsNav", () =>
  import(/*webpackChunkName:"platform_pc_other"*/ "./stepsNav")
);
